interface CrmStatusBadgeProps {
  status: string;
}

const STATUS_STYLES: Record<string, { bg: string; text: string; label: string }> = {
  active: { bg: 'bg-green-100', text: 'text-green-800', label: 'Connected' },
  error: { bg: 'bg-red-100', text: 'text-red-800', label: 'Error' },
  revoked: { bg: 'bg-gray-100', text: 'text-gray-800', label: 'Revoked' },
};

export function CrmStatusBadge({ status }: CrmStatusBadgeProps) {
  const style = STATUS_STYLES[status] ?? STATUS_STYLES.error;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${style.bg} ${style.text}`}
    >
      {style.label}
    </span>
  );
}
